// extracted by mini-css-extract-plugin
export default {"DetailsCard":"DetailsCard_DetailsCard__e6HCw","CardHeader":"DetailsCard_CardHeader__CsaT-","Title":"DetailsCard_Title__jWjai","Summary":"DetailsCard_Summary__gXZX2"};